import React, {useContext, useMemo, useState} from "react";
import {UserContext} from "../user/UserContext";
import {maxiGet, maxiPost} from "../core/maxios";
import {Container} from "../core/components/container";
import Status from "../core/status";
import {FormContextWrapper} from "../core/form_context";
import {CheckboxInput, TextfieldInput} from "../core/input/basic";
import {InfoTooltip, Loader, MaxBtn} from "../core/components/components";
import SelectFieldInput2 from "../core/input/select2";
import {FileUpload} from "../core/input/fileupload";
import {checkPermissions} from "../club/permissionsHelpers";

export function PraeSettings({child_ID, close}) {
    const context = useContext(UserContext)
    const [{error, loading}, setStatusVar] = useState({})
    const [state, setState] = useState({child_ID})
    const submit = () => maxiPost("/prae/settings", state, {setStatusVar}).then(close)

    useMemo(() => maxiGet(`/prae/settings/${child_ID}`, {setStatusVar}).then((data) => {
        if (data.ID) {
            setState(data)
        }
    }), [child_ID]);

    return <Container name={"Pauschale Reisekosten-Aufwands-Entschädigung"}>
        <Status type={"error"} text={error}/>
        <FormContextWrapper value={{state, setState}} onSubmit={submit}>
            <TextfieldInput name={"SVN"} tag={"svn"}/>
            <CheckboxInput name={<>SVN ausländisch <InfoTooltip>betrifft beschränkt steuerpflichtige Personen mit Wohnsitz im Ausland, die PRAE stellt nicht den Hauptberuf dar</InfoTooltip></>} tag={"svnAbroad"}/>
            <TextfieldInput name={"IBAN"} tag={"iban"} ph={"AT123412421412414"}/>
            <TextfieldInput name={"Standard-Stundensatz (€)"} tag={"defaultRate"}/>
            <SelectFieldInput2 tag={"activity"} name={"Standard-Tätigkeit"} multiple selectives={[
                "Sportler", "Sportarzt", "Trainer", "Zeugwart", "Lehrwart", "Kampfrichter", "Übungsleiter", "Rennleiter", "Masseur", "Funktionär", "Platz-/Zeugwart", "Fahrtendienst", "Streckenposten", "technische Hilfedienste", "sonstige ehrenamtliche Tätigkeiten", "Sportbetreuer", "Kampfrichter",
                "Rennleiter", "Instruktor", "Ausbildner", "mildtätige Tätigkeit", "kommunalsteuerbefreite Tätigkeit"]
                .map(k => ({label: k, value: k}))}/>
            <FileUpload name={"Unterschrift persönlich"} tag={"signaturePerson"} setStateParent={(n) => setState(old => ({...old, ...n}))}/>
            {
                checkPermissions(context, "prae") && context.user?.ID == child_ID &&
                <FileUpload name={"Unterschrift für Verein"} tag={"signatureClub"} setStateParent={(n) => setState(old => ({...old, ...n}))}/>
            }

            <MaxBtn>Speichern</MaxBtn> <Loader loading={loading}/>
        </FormContextWrapper>
    </Container>
}